app.run(['$q', '$timeout', '$transitions', '$rootScope', 'navService', 'authService', 'gameService', 'freeGameService', 'gameDayAuthService', 'adminAuthService', 'locationService', 'mdContentService', 'pushService', function ($q, $timeout, $transitions, $rootScope, navService, authService, gameService, freeGameService, gameDayAuthService, adminAuthService, locationService, mdContentService, pushService) {
	$transitions.onStart({}, function(transition) {
		if (transition.to().name.indexOf("teacher.") === 0) {
			if (!gameDayAuthService.isAuthenticated()) {
				return transition.router.stateService.target('404');
			}
			return true;
		} else if (transition.to().name.indexOf("student") === 0 || transition.to().name.indexOf("teacherapp") === 0) {
			if (transition.to().name === "student.login") {
				return true;
			}

			if (transition.to().name === "student.freegameperform") {
				return $q(function(resolve, reject) {
	            	freeGameService.setupFreeGame().then(function() {
	            		resolve(true);
	            	}, function() {
	            		reject(false);
	            	});
				});
			}

			if (transition.to().name === "teacherapp") {
				return transition.router.stateService.target('teacherapp.welcome');
			}

			return $q(function(resolve, reject) {
				authService.isAuthenticated().then(function(authStatus) {
					if (authStatus == false) {
						resolve(transition.router.stateService.target('student.login'));
						return;
					}

					locationService.ensureRunning().then(function() {
						pushService.ensureRunning();
					}, function() {
						pushService.ensureRunning();
					});

					authService.ensureGameDataIsLoaded().then(function() {
						if (transition.to().name === "student") {
	                        if (gameService.isWelcomeNotFinished()) {
	                            resolve(transition.router.stateService.target('student.welcome'));
	                            return;
	                        } else if (gameService.isGameDone()) {
	                            resolve(transition.router.stateService.target('student.trophy'));
	                            return;
	                        } else {
	                            resolve(transition.router.stateService.target('student.exercises'));
	                            return;
	                        }
						} else if (transition.to().name === "student.welcome") {
							if (!gameService.isWelcomeNotFinished()) {
								if (!gameService.isGameDone()) {
									resolve(transition.router.stateService.target('student.exercises'));
									return;
								} else {
									resolve(transition.router.stateService.target('student.trophy'));
									return;
								}
							}
						} else if (transition.to().name.indexOf("student.exercise") === 0) {
							if (gameService.isWelcomeNotFinished()) {
								resolve(transition.router.stateService.target('student.welcome'));
								return;
							}
							if (gameService.isGameDone()) {
								resolve(transition.router.stateService.target('student.trophy'));
								return;
							}
						} else if (transition.to().name === "student.trophy") {
							if (!gameService.isGameDone()) {
								resolve(transition.router.stateService.target('student.exercises'));
								return;
							}
						}
						resolve(true);
					}, function() {
						console.log("gameData not loaded!");
						reject(false);
					});
				}, function() {
					console.log("not authed!");
					reject(false);
				});
			});
		} else if (transition.to().name.indexOf("preview.") === 0) {
			if (gameDayAuthService.isAuthenticated()) {
				return true;
			}
			if (adminAuthService.isAuthenticated()) {
				return true;
			}
		}

		if (!adminAuthService.isAuthenticated()) {
			window.location = "/admin";
			return;
		}

		return true;
	});

	$transitions.onSuccess({}, function(transition) {
		navService.close();
	});

	$rootScope.$on('$viewContentLoaded', function(event) {
		mdContentService.triggerSyntheticScrollEvent();
	});
}]);
